import { createHTTPActions } from 'src/app/core/store/index';
import { IAccountSite } from '../../../shared/models/account-site.model';

export enum EAccountSitesActions {
  getAccountSites = '[AccountSites] Get Account Sites',
}

const [getAccountSites, getAccountSitesSuccess, getAccountSitesError] = createHTTPActions<void, IAccountSite[], Error>(
  EAccountSitesActions.getAccountSites,
);

export const ACCOUNT_SITES_ACTIONS = {
  getAccountSites,
  getAccountSitesSuccess,
  getAccountSitesError,
};
